export default (theme) => ({
  feesForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '95%',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  formHeader: {
    margin: 0,
    fontSize: 27,
    [theme.breakpoints.down('xl')]: {
      fontSize: 22,
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  incomeSelectField: {
    margin: '10px auto 0 35px',
    width: '80%',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  insurerLabel: {
    marginTop: 5,
    color: theme.palette.font.main,
  },
  payment: {
    marginTop: 30,
  },
  controlButton: {
    alignSelf: 'flex-end',
  },
  backButton: {
    margin: 25,
  },
});
